export interface SectorModel {
  id: string
  labels: Record<string, string>
  createdAt?: string
  updatedAt?: string
}

export const getSectorLabel = (sector: SectorModel, lang: string): string =>
  sector.labels?.[lang] ?? sector.labels?.['en'] ?? sector.id
